export const authHeader = (token) => `Bearer ${token}`;

export const resolveUrl = (url, get) => url.replace('{{backendUrl}}', get('backend.backendUrl'));

// The tenant reaches Form as a URL param, then persists in localStorage for later reloads
const getTenant = () => {
  const queryTenant = new URLSearchParams(window.location.search).get('tenant');
  if (queryTenant) {
    localStorage.setItem('wfb_tenant', queryTenant);
    return queryTenant;
  }
  return localStorage.getItem('wfb_tenant');
};

/*
 * Replaces the {{tenant}} placeholder in every redirect URL, once at startup.
 * With tenant = 'acme', get('url') returns:
 *   desk: { overrides: ['10', '22'],
 *           signout: 'https://ids4.wirk.io/SignOut',
 *           backnav: 'http://manager.wirk.io/{{tenant}}/forms' }
 * and the config ends up holding:
 *   desk: { overrides: ['10', '22'],
 *           signout: 'https://ids4.wirk.io/SignOut',
 *           backnav: 'http://manager.wirk.io/acme/forms' }
 * Non-string values (overrides) and URLs without the placeholder are left untouched.
 */
export const prepareConfig = (get, set, conf) => {
  const tenant = getTenant();
  if (!tenant) {
    return;
  }

  const sites = get('url');
  Object.keys(sites).forEach((key) => {
    const site = sites[key];
    Object.keys(site).forEach((urlKey) => {
      if (typeof site[urlKey] === 'string') {
        set(conf, `url.${key}.${urlKey}`, site[urlKey].replace('{{tenant}}', tenant));
      }
    });
  });
};
